import { render, staticRenderFns } from "./funnel-input-select.vue?vue&type=template&id=01b90bc8&scoped=true"
import script from "./funnel-input-select.vue?vue&type=script&lang=js"
export * from "./funnel-input-select.vue?vue&type=script&lang=js"
import style0 from "./funnel-input-select.vue?vue&type=style&index=0&id=01b90bc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b90bc8",
  null
  
)

export default component.exports